// removed by extract-text-webpack-plugin
module.exports = {"base":"_3WJ6R","epicLogo":"_3Qe8d","logo":"jyTn8","container":"_1jjPo","helpicon":"_31svM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.scss
// module id = 1398
// module chunks = 0